@if (key(); as key) {
  <osp-image [src]="directImage() ? key : (key | imageKeyFormat: size())"
             [altText]="altText()"
             [directImage]="directImage()"
             [customerId]="customerId()"/>
}
